import request from '../../../components/api/api';
import { ROOT_URL } from '../../../config';
import { SETTING_TYPE_SECTION, SETTING_TYPE_IMAGE, SETTING_TYPE_VIDEO } from './constants';

import {
    fetchedSectionSettings,
    fetchedImageSettings,
    fetchedSectionsVideoSettings
} from './actions';

export function fetchSectionSettings() {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/sections-settings?type=${SETTING_TYPE_SECTION}`,
            method: 'GET',
        };

        return request(options, dispatch)
            .then(response => dispatch(fetchedSectionSettings(response.data)));
    }
}

export function fetchImageSettings() {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/sections-settings?type=${SETTING_TYPE_IMAGE}`,
            method: 'GET',
        };

        return request(options, dispatch)
            .then(response => dispatch(fetchedImageSettings(response.data)));
    }
}

export function fetchVideoSettings() {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/sections-settings?type=${SETTING_TYPE_VIDEO}`,
            method: 'GET',
        };

        return request(options, dispatch)
            .then(response => dispatch(fetchedSectionsVideoSettings(response.data)));
    }
}


// WEBPACK FOOTER //
// ./src/containers/pages/settings/thunks.js